import getRegionOutlineAnnotationMaps from "./getRegionOutlineAnnotationMaps.js";
import LeaderLines from "./LeaderLines";
import { useState, useContext } from 'react';
import { useSelector, useStore } from 'react-redux';
import { GridCellContext } from './Contexts';
import RotationContainerSvg from './RotationContainerSvg';
import G from './Getters';
import { SelectedItemsContext } from './Contexts';
import { AnnotationStyleContext } from './Contexts';
import { useFigurePanelId } from './FigurePanelIdProvider';


export default function SubregionOutlineLayer({
  node,
  nodeId,
  nodes,
  inlineCrop,
  imageSetId,
  regions,
  subregionAtns,
  annotationId,

  onEvent,

}){

  /*
   nodeId selected => regionId
  */

  const figurePanelId = useFigurePanelId();
  const selectedItems = useContext(SelectedItemsContext);
  const selectedNodes = selectedItems?.expansionNodes || [];
  let cellLocation = useContext(GridCellContext);

  //let annotationId = regions[ node.value.regionId ];
  let nodeChildren = node.c;
  if( !nodeChildren ){
    debugger;
  }
  let regionOutlineNodeIds = nodeChildren.filter(x => nodes[x].type === "regionOutline")

  const [ containerBounds, setContainerBounds ] = useState({});

  const store = useStore();
  const state = store.getState();
  

  if( Object.keys(cellLocation||[]).length === 0 ){
    return null;
  }
  

  let regionOutlineNodes = Object.fromEntries(regionOutlineNodeIds.map(_id => {
      return [ _id,
        G.getEvaluatedFigurePanelCellNodeValue(state,{nodeId:_id, cellLocation,figurePanelId})
      ]
  }))

 
  let { 
    regionIdByAtnId, 
    nodeIdByAtnId, 
    styleByAtnId ,
    selectedRegionId,
    selectedRegionOutlineId,
    regionIdToRegionOutlineNode
  } = getRegionOutlineAnnotationMaps({
    node,
    selectedNodes,
    regionOutlineNodeIds,
    regionOutlineNodes,
    regions,
    cellLocation,

  });




  let atns = G.getRelativeLsAnnotationsBoundedByAnnotationId(state,{annotationId}).filter(x => regionIdByAtnId[x._id]);

  

  return (
    <div class="absolute-cover pev-none"
      ref={el => {
        if( el ){
          let cr = el.getBoundingClientRect();
          let crDim = { width:cr.width, height:cr.height, left:cr.left, top:cr.top };

          if( JSON.stringify(crDim) !== JSON.stringify(containerBounds) ){
            setContainerBounds(crDim);
          }

        }
      }}
    >
      {containerBounds && (

        <AnnotationStyleContext.Provider value={{
          interactive:false,
          mwMarkers:{
            point:{ r:2 },
            label:{ extrasSurroundingLabelForMovability:false }
          },
          cropBoxes:{ rotationHandles:false },
          stylingByAnnotationId:styleByAtnId,
          defaultStyling:{
            interactive:false,
            stroke:"#ffffff",
            strokeWidth:1,
          },

          pathItemType:"regionOutline",



          also:() => <><LeaderLines {...{
            atns,
            regions,
            regionIdToRegionOutlineNode,
            node,
            nodeId,
            nodes,
            cellLocation,
            containerBounds,
            selectedRegionOutlineId,
            selectedRegionId,
          }}/></>,

          
          onAnnotationClick:(annotationId,e) => {

            //select it as a selected item
            e.stopPropagation();
            let targetedNodeId = nodeIdByAtnId[annotationId];

            onEvent({
              event:e,
              type:"click",
              nativeEventType:e.type,
              itemType:"expansionNode",
              node:nodes[targetedNodeId],
              nodeId:targetedNodeId
            })
          }

        }}>
          <RotationContainerSvg {...{
            interactive:false,
            atns,
            imageViewTransformation:inlineCrop,
            imageSetId,
            imgContainerBounds:containerBounds,
          }}/>
        </AnnotationStyleContext.Provider>
    
      )}

    </div>
      
    
  )

}
